module.exports = __webpack_public_path__ + "img/1557614073914400769.4a9a348a.png";